/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/signedInUserMappers";
import * as Parameters from "../models/parameters";
/** Class representing a SignedInUser. */
var SignedInUser = /** @class */ (function () {
    /**
     * Create a SignedInUser.
     * @param {GraphRbacManagementClientContext} client Reference to the service client.
     */
    function SignedInUser(client) {
        this.client = client;
    }
    SignedInUser.prototype.get = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getOperationSpec, callback);
    };
    SignedInUser.prototype.listOwnedObjects = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, listOwnedObjectsOperationSpec, callback);
    };
    SignedInUser.prototype.listOwnedObjectsNext = function (nextLink, options, callback) {
        return this.client.sendOperationRequest({
            nextLink: nextLink,
            options: options
        }, listOwnedObjectsNextOperationSpec, callback);
    };
    return SignedInUser;
}());
export { SignedInUser };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/me",
    urlParameters: [
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.User
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listOwnedObjectsOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/me/ownedObjects",
    urlParameters: [
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.DirectoryObjectListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listOwnedObjectsNextOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/{nextLink}",
    urlParameters: [
        Parameters.nextLink,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.DirectoryObjectListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
//# sourceMappingURL=signedInUser.js.map